<template>
	<div>
		<div class="newsList" v-if="windowWidth>=800">
			<div class="nl_div" v-for="(item,index) in newsList" :key="index" @click="natTo(item)" v-if="newsList.length > 0">
				<el-image class="nl_div_image" :src="item.image" :fit="'fill'"></el-image>
				<div class="nl_div_content">
					<div class="nl_div_ct_title">{{item.title}}</div>
					<div class="nl_div_ct_content">{{item.content}}</div>
					<div style="display: flex;justify-content: flex-start;color: #aaa;">{{item.createTime}}</div>
				</div>
			</div>
			<div  style="display: flex;justify-content: center;align-items: center;"  v-if="newsList.length == 0">
				<el-empty :description="$i18n.locale == 'en'?'No information':'暂无信息'"></el-empty>
			</div>
		</div>
		
		<div class="newsList2" v-if="windowWidth<=799">
			<div class="nl_div2" v-for="(item,index) in newsList" :key="index" @click="natTo(item)" v-if="newsList.length > 0">
				<el-image class="nl_div_image2" :src="item.image" :fit="'fill'"></el-image>
				<div class="nl_div_content2">
					<div class="nl_div_ct_title2">{{item.title}}</div>
					<div class="nl_div_ct_content2">{{item.content}}</div>
					<div style="display: flex;justify-content: flex-start;color: #aaa;">{{item.createTime}}</div>
				</div>
			</div>
			<div  style="display: flex;justify-content: center;align-items: center;"  v-if="newsList.length == 0">
				<el-empty :description="$i18n.locale == 'en'?'No information':'暂无信息'"></el-empty>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			//宽
			windowWidth: {
				type: Number,
				default: 0
			},
			//高
			windowHeight: {
				type: Number,
				default: 0
			},
			newsList:{
				type:Array,
				default:()=>[]
			}
		},
		data() {
			return {
			}
		},
		
		
		methods:{
			//点击跳转
			natTo(item){
				item.detailsMode = '1' //0含图文+视频+下载文件，1只图文
				this.$store.commit('CUTTING_HEIGHT',{type:this.$route.path,height:window.scrollY})
				this.$store.commit('CUTTING_HEIGHT',{type:'/productDetails',height:0})
				this.$router.push({
					path: '/productDetails',
					query:{
						data:item,
						// selector:'#product'
					},
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	
	@media only screen and (min-width:1920px) {
		.newsList{
			padding: 80px 200px;
		}
		
		.nl_div{
			padding: 20px;
			background: #f7f7f7;
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			width: 100%;
			
			.nl_div_image{
				height: 240px;
				width: 30%;
			}
			
			.nl_div_content{
				padding: 0 30px;
				width: 70%;
				cursor: pointer;
				
				.nl_div_ct_title{
					font-size: 22px;
					line-height: 28px;
					color: #1d1d1d;
					transition: all 0.5s ease;
				}
				
				.nl_div_ct_content{
					margin-top: 24px;
					font-size: 14px;
					color: #999999;
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}
		
		.nl_div_content:hover .nl_div_ct_title{
			color: #1074bc;
		}
	}
	
	@media only screen and (max-width:1920px) {
		.newsList{
			padding: 80px 200px;
		}
		
		.nl_div{
			padding: 20px;
			background: #f7f7f7;
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			width: 100%;
			
			.nl_div_image{
				height: 240px;
				width: 30%;
			}
			
			.nl_div_content{
				padding: 0 30px;
				width: 70%;
				cursor: pointer;
				
				.nl_div_ct_title{
					font-size: 22px;
					line-height: 28px;
					color: #1d1d1d;
					transition: all 0.5s ease;
				}
				
				.nl_div_ct_content{
					margin-top: 24px;
					font-size: 14px;
					color: #999999;
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}
		
		.nl_div_content:hover .nl_div_ct_title{
			color: #1074bc;
		}
	}
	
	@media only screen and (max-width:1919px) and (min-width:1440px) {
		.newsList{
			padding:60px;
		}
		
		.nl_div{
			padding: 20px;
			background: #f7f7f7;
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			width: 100%;
			
			.nl_div_image{
				height: 240px;
				width: 30%;
			}
			
			.nl_div_content{
				padding: 0 30px;
				width: 70%;
				cursor: pointer;
				
				.nl_div_ct_title{
					font-size: 22px;
					line-height: 28px;
					color: #1d1d1d;
					transition: all 0.5s ease;
				}
				
				.nl_div_ct_content{
					margin-top: 24px;
					font-size: 14px;
					color: #999999;
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}
		
		.nl_div_content:hover .nl_div_ct_title{
			color: #1074bc;
		}
	}
	
	@media only screen and (max-width:1439px) and (min-width:1200px) {
		.newsList{
			padding: 40px;
		}
		
		.nl_div{
			padding: 20px;
			background: #f7f7f7;
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			width: 100%;
			
			.nl_div_image{
				height: 240px;
				width: 30%;
			}
			
			.nl_div_content{
				padding: 0 30px;
				width: 70%;
				cursor: pointer;
				
				.nl_div_ct_title{
					font-size: 22px;
					line-height: 28px;
					color: #1d1d1d;
					transition: all 0.5s ease;
				}
				
				.nl_div_ct_content{
					margin-top: 24px;
					font-size: 14px;
					color: #999999;
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}
		
		.nl_div_content:hover .nl_div_ct_title{
			color: #1074bc;
		}
	}
	
	@media only screen and (max-width:1199px) and (min-width:800px) {
		.newsList{
			padding:20px;
		}
		
		.nl_div{
			padding: 20px;
			background: #f7f7f7;
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			width: 100%;
			
			.nl_div_image{
				height: 240px;
				width: 30%;
			}
			
			.nl_div_content{
				padding: 0 30px;
				width: 70%;
				cursor: pointer;
				
				.nl_div_ct_title{
					font-size: 22px;
					line-height: 28px;
					color: #1d1d1d;
					transition: all 0.5s ease;
				}
				
				.nl_div_ct_content{
					margin-top: 24px;
					font-size: 14px;
					color: #999999;
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
		}
		
		.nl_div_content:hover .nl_div_ct_title{
			color: #1074bc;
		}
	}
	
	@media only screen and (max-width:799.9px) {
		
			.newsList2{
				padding:12px;
			}
			
			.nl_div2{
				padding: 12px;
				background: #f7f7f7;
				margin-bottom: 12px;
				width: 100%;
				
				.nl_div_image2{
					height: 240px;
					width: 100%;
				}
				
				.nl_div_content2{
					width: 100%;
					cursor: pointer;
					
					.nl_div_ct_title2{
						margin-top: 10px;
						font-size: 1.4rem;
						line-height: 28px;
						color: #1d1d1d;
						transition: all 0.5s ease;
					}
					
					.nl_div_ct_content2{
						margin: 10px 0;
						font-size: 1rem;
						color: #999999;
						line-height: 24px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
					}
				}
			}
			
			.nl_div_content:hover .nl_div_ct_title{
				color: #1074bc;
			}
	}
</style>